export default {
feedback: {
  title: "フィードバック",
  placeholder: "メッセージを入力してください ({ contentLen }/1000文字)",
  error: "エラーメッセージです",
  uploadLimit: "画像と動画のアップロード制限",
  send: "送信",
  tipTitle: "体験向上にご協力ください",
  desc1: "ご質問を送信できます。採用された場合、サプライズギフトを受け取れます。",
  desc2: "ウェブサイトでの送信が難しい場合は、メールでも送信できます。"
}
};
